import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import DeclarationDetails from "../DeclarationDetails";
import DeclarationForm from "../DeclarationForm";
import { formatDateEdit } from "../../../../constant/DateFormatEdit";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
  GetSectorList,
  selectSectorList,
} from "../../../../features/helpandassistance/SectorListSLice";
import DeclarationFormNew from "../DeclarationFormNew";

const DeclarationsTable = ({
  tData,
  GetDeclarationType,
}: {
  tData: any;
  GetDeclarationType?: any;
}) => {
  const getStatus = (status: any) => {
    if (status == 0) return <div style={{ color: "#ffbf00" }}>PENDING</div>;
    if (status == 1) return <div style={{ color: "#00aa00" }}>APPROVED</div>;
    if (status == 2) return <div style={{ color: "#e31837" }}>REJECTED</div>;
    if (status == 3) return <div style={{ color: "#e31837" }}>SEND BACK</div>;
  };

  return (
    <>
      <Table style={styles.border} responsive>
        <tr style={styles.border}>
          <th className="py-3 ps-3" style={styles.tableHeading}>
            COI Sector
          </th>
          {/* <th className="py-3 ps-3" style={styles.tableHeading}>
            Conflict Type
          </th> */}
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Conflict Category
          </th>
         
          <th
            className="py-3 ps-3"
            style={{ ...styles.tableHeading, width: "80px" }}
          >
            Created On
          </th>
          <th className="py-3 ps-3" style={styles.tableHeading}>
            Status
          </th>
          <th className="py-3 ps-3" align="center" style={styles.tableHeading}>
            Actions
          </th>
        </tr>

        {tData?.length > 0 ? (
          tData.map((val: any) => {
            return (
              <>
                <tr style={styles.border}>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.coiSectorName}
                  </td>
                  {/* <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.declearationCategoryType}
                  </td> */}
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {val?.conflictCategoryMasterTitle}
                  </td>
                  
                  <td
                    className="py-3 ps-3"
                    style={{ ...styles.tableContents, width: "100px" }}
                  >
                    {formatDateEdit(val?.createdDate)
                      ?.split("-")
                      .reverse()
                      .join("-")}
                  </td>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    {getStatus(val?.status)}
                  </td>
                  <td className="py-3 ps-3" style={styles.tableContents}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <DeclarationDetails
                        records={val}
                        GetDeclarationType={GetDeclarationType}
                        type="myDeclaration"
                      />
                      {val?.status == 3 && (
                        <DeclarationFormNew isEdit={true} editData={val} />
                      )}
                    </div>
                  </td>
                </tr>
              </>
            );
          })
        ) : (
          <tr style={styles.border}>
            <td className="py-3" style={styles.text1} colSpan={6}>
              You have no declarations
            </td>
          </tr>
        )}
      </Table>
    </>
  );
};

const styles: any = {
  divWhite: {
    backgroundColor: "#fffff",
    padding: "24px",
  },
  tableHeading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
  },
  tableContents: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "normal",
  },
  border: {
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
  },
  text1: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "normal",
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    color: "#6d6e71",
    textAlign: "center",
  },
};

export default DeclarationsTable;
